export const media = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить файл <b>{description}<b>?`
    }
  },

  list: {
    button_upload: 'Загрузить файл',
    add_media: 'Добавить медиа файлы'
  },

  table: {
    field: {
      play: 'Воспроизведение',
      created_at: 'Дата загрузки'
    }
  }
};
